// src/utils/rates.js
// Default rate configuration. If you adjust these values in the
// settings page, a copy of your changes is saved to localStorage
// under the key "ci_rates". The helper functions below read from
// and write to that key so that changes persist across reloads. When
// no saved configuration exists the defaults defined here are used.
const DEFAULT_RATES = {
  base: 55.0,
  perMile: 1.9,
  deadheadPerMile: 1.0,

  includeMilesInFuel: true,
  fuelPct: 0.1,

  weightThreshold: 50,
  weightPerLbOver: 0.20,

  waitGraceMinutes: 15,
  waitPerMinute: 0.67,

  holdoverPerNight: 50.0,
  afterHoursFlat: 100.0,
  dedicatedPerHour: 71.5,

  // thresholds
  mileageFreeMiles: 20,
  deadheadFreeMiles: 100,
};

/**
 * Retrieve the current rate configuration from localStorage. When
 * running in a browser the user can override any of the default
 * values by navigating to the Settings page and saving changes. This
 * helper attempts to read from localStorage and falls back to the
 * defaults if nothing is saved or the parse fails.
 */
export function getRates() {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const raw = window.localStorage.getItem("ci_rates");
      if (raw) {
        const stored = JSON.parse(raw);
        if (stored && typeof stored === "object") {
          return { ...DEFAULT_RATES, ...stored };
        }
      }
    } catch (e) {
      // swallow parse errors and fall back to defaults
    }
  }
  return { ...DEFAULT_RATES };
}

/**
 * Persist a rate configuration to localStorage. Only keys that exist
 * on the default configuration will be saved; extra keys are ignored.
 */
export function saveRates(rates) {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const valid = {};
      Object.keys(DEFAULT_RATES).forEach((k) => {
        if (Object.prototype.hasOwnProperty.call(rates, k)) {
          valid[k] = rates[k];
        }
      });
      window.localStorage.setItem("ci_rates", JSON.stringify(valid));
    } catch (e) {
      // localStorage may be full or unavailable; ignore
    }
  }
}

// Export the defaults for backwards compatibility. Other modules that
// import { RATES } will still receive the original defaults. Use the
// getRates() function to retrieve an up‑to‑date configuration.
export const RATES = DEFAULT_RATES;

// Default export returns the current effective rate configuration. This
// makes it convenient to `import rates from "./rates"` and get
// whatever is currently configured without having to call getRates()
// manually. See task‑create and other pages for usage.
export default getRates;





